import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const adminDiagnosticsApi = createApi({
  reducerPath: "adminDiagnosticsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/admin/diagnostics`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["AdminDiagnostics"],
  endpoints: (builder) => ({
    getDiagnosticsOverview: builder.query({
      query: (args = {}) => {
        const params = {};
        if (args.limit) params.limit = args.limit;
        return { url: "", params };
      },
      providesTags: [{ type: "AdminDiagnostics", id: "OVERVIEW" }],
    }),
    getBackupDiagnostics: builder.query({
      query: (args = {}) => ({ url: "/backups", params: args }),
      providesTags: [{ type: "AdminDiagnostics", id: "BACKUPS" }],
    }),
    triggerSqlBackup: builder.mutation({
      query: (body = {}) => ({
        url: "/backups/trigger",
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "AdminDiagnostics", id: "OVERVIEW" },
        { type: "AdminDiagnostics", id: "BACKUPS" },
        { type: "AdminDiagnostics", id: "AUDIT" },
      ],
    }),
    getErrorReports: builder.query({
      query: (args = {}) => ({ url: "/error-reports", params: args }),
      providesTags: [{ type: "AdminDiagnostics", id: "ERROR_REPORTS" }],
    }),
    updateErrorReportReview: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/error-reports/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [
        { type: "AdminDiagnostics", id: "ERROR_REPORTS" },
        { type: "AdminDiagnostics", id: "AUDIT" },
      ],
    }),
    getHealthDiagnostics: builder.query({
      query: () => "/health",
      providesTags: [{ type: "AdminDiagnostics", id: "HEALTH" }],
    }),
    getDatabaseDiagnostics: builder.query({
      query: () => "/database",
      providesTags: [{ type: "AdminDiagnostics", id: "DATABASE" }],
    }),
    getAuditLog: builder.query({
      query: (args = {}) => ({ url: "/audit", params: args }),
      providesTags: [{ type: "AdminDiagnostics", id: "AUDIT" }],
    }),
    getEmailJobs: builder.query({
      query: (args = {}) => ({ url: "/email-jobs", params: args }),
      providesTags: [{ type: "AdminDiagnostics", id: "EMAIL_JOBS" }],
    }),
    getPreference: builder.query({
      query: (key) => `/preferences/${encodeURIComponent(key)}`,
      providesTags: (result, error, key) => [
        { type: "AdminDiagnostics", id: `PREFERENCE:${key}` },
      ],
    }),
    updatePreference: builder.mutation({
      query: ({ key, value }) => ({
        url: `/preferences/${encodeURIComponent(key)}`,
        method: "PUT",
        body: { value },
      }),
      invalidatesTags: (result, error, { key }) => [
        { type: "AdminDiagnostics", id: `PREFERENCE:${key}` },
      ],
    }),
  }),
});

export const {
  useGetDiagnosticsOverviewQuery,
  useGetBackupDiagnosticsQuery,
  useGetErrorReportsQuery,
  useUpdateErrorReportReviewMutation,
  useGetHealthDiagnosticsQuery,
  useGetDatabaseDiagnosticsQuery,
  useGetAuditLogQuery,
  useGetEmailJobsQuery,
  useGetPreferenceQuery,
  useTriggerSqlBackupMutation,
  useUpdatePreferenceMutation,
} = adminDiagnosticsApi;
export default adminDiagnosticsApi;
export { adminDiagnosticsApi };
